import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CompetenciesService } from '../views/competencies/competencies.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FormControl, FormsModule } from '@angular/forms';
import { ProjectTechstackService } from '../project-techstack/project-techstack.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../components/loader/loader.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-tech-stack-grid',
  templateUrl: './tech-stack-grid.component.html',
  styleUrls: ['./tech-stack-grid.component.css']
})
export class TechStackGridComponent implements OnInit, OnChanges {
  @Input() serviceLinesMap: any;
  @Input() clintId: number;
  @Input() projectId: number;
  @Input() managerId: number;
  @Input() projectData: any;
  skillsets: any[] = [];
  myControl = new FormControl();
  public skillsetValues: any[] = [];
  suggestionsVisible: boolean;
  options: any[] = [];
  filteredOptions: Observable<any[]> | undefined;
  selectedCompetencyId: any;
  selectedTechStackId: any;
  filteredSkillsets: any[] = [];
  skillsetNames: string[] = [];
  selectedCompitencies: any[] = [];
  @Input() showGrid: boolean;
  constructor(private service: CompetenciesService, private techstackService: ProjectTechstackService, public toaster: ToastrService, private loadingService: LoaderService) {
  }

  ngOnInit(): void {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.clintId && this.projectId && this.managerId && this.projectData && this.showGrid) {
      if (this.projectData?.competencies && this.serviceLinesMap && this.serviceLinesMap.length > 0) {
        this.projectData?.competencies.forEach(x => {
          let serviceLine = this.serviceLinesMap.find(y => y.id == x.id);
          if (serviceLine) {
            serviceLine.serviceLines.map(k => {
              if (x.serviceLines.find(z => z.id == k.id)) {
                k.isSelected = true;
              }
            });
            serviceLine.selectedPrimarySkills = x.primarySkills;
            serviceLine.selectedSecondarySkills = x.secondarySkills;

          }
        });
        this.serviceLinesMap.forEach(x => {
          let competency = x.serviceLines?.find(y => y.isSelected && y.isSelected == true)
          if (competency) {
            x.showSkills = true;
            this.serviceLineChecked({ checked: true }, x);
          }
          else {
            x.hideSkillsets = true;
          }
        })
      }
      else if (this.serviceLinesMap && this.serviceLinesMap.length > 0) {
        this.serviceLinesMap.forEach(x => {
          x.hideSkillsets = true;
        });

      }

    }
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }


  getSkillsets(competencyId: number, subCompetencyIds: number[]) {
    const skillsets = this.filteredSkillsets
      .filter(skillset =>
        skillset.competencyId === competencyId &&
        subCompetencyIds.includes(skillset.subCompetencyId)
      );
    return skillsets;
  }
  toggleCompetencyDropdown() {
    this.suggestionsVisible = !this.suggestionsVisible;
  }

  selectedTechStack: any[] = [];
  isTechStackTableVisible: boolean = false;
  selectedCompetencyIds: Set<number> = new Set<number>();

  serviceLineChecked(event: any, competency: any) {
    if (!event.checked && !competency.serviceLines.find(x => x.isSelected)) {
      competency.showSkills = false;
      delete competency.selectedPrimarySkills;
      delete competency.selectedSecondarySkills;
      competency.hideSkillsets = true;
    }
    else if (competency.skillSets && competency.skillSets.length > 0) {
      competency.showSkills = true;
      competency.hideSkillsets = false;
    }
    else {
      competency.showSkills = true;
      competency.hideSkillsets = true;
      this.techstackService.getSkillsets(competency.id == 7 ? 2 : competency.id).subscribe((response: any) => {
        let data = response.data;
        if (competency.hideSkillsets) {
          delete competency.hideSkillsets;
        }
        this.updateSkillSets(data, competency);

      })
    }
  }
  updateSkillSets(data: any, competency: any) {
    if (data && data.length > 0 && this.serviceLinesMap) {
      let competencySkillSet = this.serviceLinesMap.find(x => x.id == competency.id);
      if (competencySkillSet) {
        if (competency.id == 7) {
          competencySkillSet.skillSets = data.filter(x => x.subCompetencyId == 3);
        }
        else if (competency.id == 2) {
          competencySkillSet.skillSets = data.filter(x => x.subCompetencyId != 3);
        }
        competencySkillSet.skillSets = data;

      }
      this.updateSkillSets(data, competency);
    }
  }


  onOptionSelected(event: MatAutocompleteSelectedEvent) {
    const selectedOption = event.option.value;
    this.selectedTechStackId = selectedOption;
    const data = this.selectedCompetencyId.map((id, index) => ({ competencyId: id, subCompetencyIds: [this.selectedTechStackId.id] }));
  }
  toggleSkillSets(competency: any, subCompetenciess: any) {
    if (!(subCompetenciess.skillsets && subCompetenciess.skillsets.length > 0)) {
      this.techstackService.getSkillsets(competency.competencyName[0].id).subscribe((response: any) => {
        let data = response.data;

        competency.subCompetenciess.map(x => {
          x.skillsets = data.filter(p => p.subCompetencyId == x.id);
        })

      })
    }
  }

  getServiceLineValues(event: Event, competency: any, skillSet: any) {
    skillSet.selectedSkillSets = event;
  }

  validateSubmitData() {
    if (this.serviceLinesMap && this.serviceLinesMap.find(x => x.serviceLines?.find(y => y.isSelected && y.isSelected == true))) {
      let selectedServiceLines = this.serviceLinesMap.filter(x => x.serviceLines?.find(y => y.isSelected && y.isSelected == true));
      let notSelectedSills = selectedServiceLines.find(x =>
        !x.selectedPrimarySkills || (x.selectedPrimarySkills && x.selectedPrimarySkills.length == 0)
      );
      if (notSelectedSills) {
        this.toaster.error(`Please select skills for ${notSelectedSills.name}`);
        return false;
      }
      else {
        return true;
      }
    }
    else {
      this.toaster.error("Please select Servicelines");
      return false;
    }
  }

  submit() {
    let selectedData = this.serviceLinesMap.filter(x => x.serviceLines?.find(y => y.isSelected && y.isSelected == true));
    if (this.validateSubmitData()) {
      let projectCompetencyData = {
        id: this.projectData?.id ?? 0,
        projectId: this.projectId,
        clientId: this.clintId,
        managerId: this.managerId,
        competencies: selectedData.map(x => {
          return {
            id: x.id,
            name: x.name,
            primarySkills: x.selectedPrimarySkills,
            secondarySkills: x.selectedSecondarySkills,
            serviceLines: x.serviceLines.filter(x => x.isSelected)
          }
        })
      }
      this.techstackService.addOrUpdateProjectTechstack(projectCompetencyData).subscribe((response: any) => {
        this.toaster.success("Data saved successfully");
      })
    }
  }

}
